import React, { useState } from "react";
import Jumbotron from "react-bootstrap/Jumbotron";
import Toast from "react-bootstrap/Toast";

// Importing the Bootstrap CSS
import "./bootstrap.min.css";
import "./App.css";

const App = () => (
  <Jumbotron fluid>
    <h1 className="header">Witzelsucht.net</h1>
  </Jumbotron>
);

export default App;
